import { Flex, Typography } from 'antd'
import React, { useCallback, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { ISSUED_CHECK_STATUS } from '../index.constant'
import {
  colorBgButtonSubtleHovered,
  colorBgErrorBold,
  colorBgErrorHovered,
  colorBgSuccessHovered,
  colorBgWarningHovered,
  colorTextSubtle,
  success,
  warning,
} from 'src/app/themes/primaryThemeDefault'

export interface IStatusTag {
  status: ISSUED_CHECK_STATUS
}

const StatusTag: React.FC<IStatusTag> = (props) => {
  const { status } = props
  const { t } = useTranslation()

  const getConfig = useCallback(
    (status: ISSUED_CHECK_STATUS) => {
      switch (status) {
        case ISSUED_CHECK_STATUS.PROCESSED:
          return {
            color: success,
            backgroundColor: colorBgSuccessHovered,
            text: t(`SubmitIssuedCheck:table.processed`),
          }
        case ISSUED_CHECK_STATUS.PROCESSING:
          return {
            color: warning,
            backgroundColor: colorBgWarningHovered,
            text: t(`SubmitIssuedCheck:table.processing`),
          }
        case ISSUED_CHECK_STATUS.PROCESSED_WITH_EXCEPTION:
          return {
            color: '#F8C100',
            backgroundColor: '#FFFAE7',
            text: t(`SubmitIssuedCheck:table.processed_with_exceptions`),
          }
        case ISSUED_CHECK_STATUS.REJECTED:
          return {
            color: colorTextSubtle,
            backgroundColor: colorBgButtonSubtleHovered,
            text: t(`SubmitIssuedCheck:table.rejected`),
          }
        case ISSUED_CHECK_STATUS.FAILED:
          return {
            color: colorBgErrorBold,
            backgroundColor: colorBgErrorHovered,
            text: t(`SubmitIssuedCheck:table.failed`),
          }
        default:
          return {
            backgroundColor: '',
            color: '',
            text: t(`SubmitIssuedCheck:table.rejected`),
          }
      }
    },
    [t],
  )

  const configs = useMemo(() => getConfig(status), [getConfig, status])

  return (
    <Flex
      style={{
        borderRadius: 27,
        padding: '4px 12px',
        backgroundColor: configs.backgroundColor,
        width: 'fit-content',
        alignItems: 'center',
        gap: 4,
      }}
    >
      <div
        style={{
          backgroundColor: configs.color,
          minWidth: 4,
          width: 4,
          height: 4,
          borderRadius: 50,
        }}
      />
      <Typography
        style={{
          color: configs.color,
          fontSize: 14,
          fontWeight: 700,
          wordBreak: 'keep-all',
        }}
      >
        {configs.text}
      </Typography>
    </Flex>
  )
}

export default StatusTag
